import {Component, EventEmitter, Input, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import {WidgetRiskAssessmentV0Implemented} from "../../v0/models/widget-risk-assessment-v0-args.dto";
import {WraV0Row} from "../models/wra-v0-row";
import {IoniconsOutline} from "@pt/pt-models";

@Component({
  selector: 'pt-wra-implemented-value-selector',
  template: `
    <div class="d-flex flex-row">
      <!--      <pt-icon *ngIf="warningChangeGlobalMeasure"-->
      <!--               [key]='IconWarning'-->
      <!--               container='body'-->
      <!--               ngbTooltip="{{warningChangeGlobalMeasure}}"-->
      <!--               class="bg-warning">-->
      <!--      </pt-icon>-->
      <ng-template #tipContent>
        <div [innerHTML]="'MESSAGE.WRA_CHANGED_VALUE' | translate: { value: warningChangeGlobalMeasure } "></div>
      </ng-template>

      <pt-icon *ngIf="warningChangeGlobalMeasure"
               [key]='IconWarning'
               container='body'
               [ngbTooltip]="tipContent"
               class="bg-warning">
      </pt-icon>



      <pt-icon *ngIf="warningChangeCurrentValue"
               [key]='IconWarning'
               container='body'
               ngbTooltip="{{warningChangeCurrentValue}}"
               class="bg-warning">
      </pt-icon>

      <!--      <pt-icon *ngIf="warningChangeCurrentValue"-->
      <!--               [key]='IconWarning'-->
      <!--               container='body'-->
      <!--               [ngbTooltip]="'MESSAGE.WRA_CHANGED_VALUE' | translate"-->
      <!--               class="bg-warning">-->
      <!--      </pt-icon>-->

      <ng-select
        class="wra-select-row"
        appendTo="body"
        [disabled]="!editable"
        [items]="implementedValuesWithEmpty"
        [style.border-color]="selectedImplementedValue?.color"
        [style.color]="currentValueTextColor"
        [(ngModel)]="selectedImplementedValue"
        (ngModelChange)="valueSelectedChange($event)"
        [searchable]='false'
        [clearable]='false'>

        <ng-template ng-label-tmp let-item="item">
          <div class="ng-select-custom-value text-truncate"
               container='body'
               ngbTooltip="{{item.label}}">
            {{ item.label }}
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div container='body'
               class="text-truncate"
               ngbTooltip="{{item.label}}">
            {{ item.label }}
          </div>
        </ng-template>
      </ng-select>
    </div>

  `,
  styles: [`
    .wra-select-row {
      width: 160px;
      border: 1px solid white;
      background: white;
    }

    .wra-select-row .ng-select-container {
      height: 25px !important;
      min-height: 25px !important;
      max-height: 25px !important;
      border-radius: 0;
      padding-top: 3px !important;
      /*background: transparent !important;*/
      color: #333333 !important;
    }


    .very-high {
      border: solid 1px var(--ptHigh);
    }

    .high {
      border: solid 1px var(--ptHigh);
    }

    .medium-high {
      border: solid 1px var(--ptMediumHigh);
    }

    .medium {
      border: solid 1px var(--ptMedium);
    }

    .medium-low {
      border: solid 1px var(--ptMediumLow);
    }

    .low {
      border: solid 1px var(--ptLow);
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class WraV0ImplementedValueSelectorComponent implements OnChanges {
  @Input() selectedGlobalMeasure: number;
  @Input() editable: boolean;
  @Input() row!: WraV0Row;
  @Input() emptyLabel!: string;
  @Input() implementedValues!: WidgetRiskAssessmentV0Implemented[];
  @Output() changedImplementedValue = new EventEmitter<WidgetRiskAssessmentV0Implemented>();

  public currentValueTextColor = '#ffffff';
  public implementedValuesWithEmpty?: WidgetRiskAssessmentV0Implemented[];
  public selectedImplementedValue?: WidgetRiskAssessmentV0Implemented;
  public emptyImplementedValues?: WidgetRiskAssessmentV0Implemented;
  public IconWarning = IoniconsOutline.warning;
  public warningChangeGlobalMeasure?: string;
  public warningChangeCurrentValue?: string;

  ngOnChanges(): void {
    if (this.row && this.implementedValues && this.emptyLabel) {
      this.resetSelector(this.row, this.implementedValues);
    }
  }
  public valueSelectedChange(selectedImplValue: WidgetRiskAssessmentV0Implemented) {
    this.currentValueTextColor = this.calcCurrentValueTextColor(selectedImplValue);
    this.changedImplementedValue.emit(selectedImplValue);
    // this.calcWarningValue();
  }

  private resetSelector(row: WraV0Row, implementedValues: WidgetRiskAssessmentV0Implemented[]) {
    this.emptyImplementedValues = {
      value: undefined,
      label: this.emptyLabel,
      color: '#ffff83'
    }

    const iValue: WidgetRiskAssessmentV0Implemented[] = [this.emptyImplementedValues];
    this.selectedImplementedValue = undefined;
    let value: WidgetRiskAssessmentV0Implemented | undefined = undefined;

    implementedValues.forEach((r) => {
      iValue.push(r);
      if (r.value === row.widgetValue.implementedValue) {
        value = r;
      }
    })

    if (!value) {
      value = this.emptyImplementedValues;
    }
    this.currentValueTextColor = this.calcCurrentValueTextColor(value);
    this.implementedValuesWithEmpty = iValue;
    this.selectedImplementedValue = value;
    this.calcWarningValue()
  }
  private calcCurrentValueTextColor(selectedImplValue: WidgetRiskAssessmentV0Implemented): string {
    if (selectedImplValue?.value === undefined || selectedImplValue?.value === null) {
      return '#333333'
    }
    return '#ffffff'
  }


  private calcWarningValue() {
    const globalMeasureCheckValue = this.row?.globalMeasureCheckValue?.implementedValue;
    const widgetValue = this.row?.widgetValue?.implementedValue;

    const selectedImplementedValue = this.selectedImplementedValue?.value;

    if (this.row?.globalMeasureCheckValue && globalMeasureCheckValue !== selectedImplementedValue) {
      this.warningChangeGlobalMeasure = this.implementedValuesWithEmpty?.
      find((iv) => iv.value === globalMeasureCheckValue)?.label
    }

    if (widgetValue !== selectedImplementedValue) {
      this.warningChangeCurrentValue = this.implementedValuesWithEmpty?.
      find((iv) => iv.value === widgetValue)?.label
    }
  }
}
